<div #chartContainer class=" h-[180px] w-[180px]" style="width: 100%;"></div>

